import React, { useEffect, useState, useRef } from "react"
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  Row,
  Space,
  notification,
  Select,
  Tooltip,
} from "antd"
import { unwrapResult } from "@reduxjs/toolkit"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../app/store"
import styles from "./appllication.module.css"
import {
  getAcceptanceDetailListAsync,
  getBuildOtherRecipeAsync,
  getCopyDetailAsync,
  getInventoryPurchAseacceptanceGspSubmitAsync,
  getInventoryPurchAseacceptanceListAsync,
  getInventoryPurchAseacceptanceSubmitAsync,
  getInventoryReceiptsSubmitAsync,
} from "./chainSlice"
import { EditableList } from "../../compnents/list/EditableList"
import { AcceptanceColumns, CopyDetailColumns, StorageColumns } from "./columns"
import { stringTrim } from "../../utils/StringUtils"
import { DateTimeFormat, DateTimeFormatSimple } from "../../models/datetime"
import moment from "moment"
import { getStorage, selectStorage } from "../durgsystem/durgsystemSlice"
import { DepartmentDate, selectDepartData } from "../putstorage/putstorageSlice"
import { getUserName, sleectUserData } from "../putstorelist/putstorelistSlice"
import { Department } from "../../models/department"
import {
  selectUserDepartmentId,
  selectUserId,
} from "../../app/applicationSlice"
import { User } from "../../models/user"
import { Category } from "../../models/category"

const { Option } = Select

export const StorageModal = (props: {
  data: any
  visible: boolean
  category: string
  onOk: () => void
  onCancel: () => void
}) => {
  const dispatch = useDispatch<RootDispatch>()

  const [messageApi, contextHolder] = message.useMessage()

  const departmentData = useSelector(selectDepartData)

  const [form] = Form.useForm()

  const durgsystemData: any = useSelector(selectStorage)

  const userData = useSelector(sleectUserData)

  const departmentId = useSelector(selectUserDepartmentId)

  const userId = useSelector(selectUserId)

  const [pageLoading, setPageLoading] = useState(false)

  const [loading, setLoading] = useState(false)

  const [sureLoading, setSureLoading] = useState(false)

  const [page, setPage] = useState<any>({
    items: [],
    total: 0,
  })

  const [params, setParams] = useState<any>({
    current: 1,
    size: 10,
  })

  const required = [
    {
      title: "批号",
      dataIndex: "batchNo",
    },
    {
      title: "到货数量",
      dataIndex: "totalQuantity",
    },
    {
      title: "生产日期",
      dataIndex: "productDate",
    },
    {
      title: "有效期",
      dataIndex: "deadline",
    },
    {
      title: "到货数量",
      dataIndex: "totalQuantity",
    },
    {
      title: "验收合格数量",
      dataIndex: "qualifiedQuantity",
    },
    {
      title: "验收不合格数量",
      dataIndex: "defectiveQuantity",
    },
    {
      title: "入库单价",
      dataIndex: "unitPrice",
    },
    {
      title: "零售单价",
      dataIndex: "retailPrice",
    },
    {
      title: "入库数量",
      dataIndex: "realCount",
    },
    {
      title: "质量状况",
      dataIndex: "qualityStatus",
    },
    {
      title: "验收结论",
      dataIndex: "acceptanceConclusion",
    },
  ]

  // 严格校验函数
  const validateRequiredFields = (data: any) => {
    const requiredFields = required
      .filter((col) => col.dataIndex)
      .map((col) => col.dataIndex)
    let isValid = true
    let fieldTitle: any = []
    data.forEach((item: any, rowIndex: number) => {
      requiredFields.forEach((field) => {
        if (!(field in item) || item[field] == null || item[field] === "") {
          isValid = false
          fieldTitle.push(
            required.find((col) => col.dataIndex === field)?.title
          )
        }
      })
    })
    fieldTitle = [...(new Set(fieldTitle) as any)].join(",")
    if (fieldTitle?.length) {
      notification.error({
        message: `请填写必填项${fieldTitle}`,
      })
    }
    return isValid
  }

  const submit = (type: number) => {
    form.validateFields().then((values) => {
      if (validateRequiredFields(page.items)) {
        type == 1 ? setLoading(true) : setSureLoading(true)
        const filterData = page.items?.filter((v: any) => {
          return Number(v.qualifiedQuantity) + Number(v.defectiveQuantity) != Number(v.totalQuantity)
        })
        if(filterData?.length) {
          notification.error({
            message: `${filterData[0]?.name}的验收合格数量和验收不合格数量之和需等于到货数量`,
          })
        } else {
          const storehouseName =
          (durgsystemData.find(
            (d: any) => d.storehouseId === values.storehouseId
          ) as any)?.storehouseName || "";
        const departmentName =
          (departmentData.find(
            (d: any) => d.id === values.departmentId
          ) as any)?.name || "";
        const userName =
          (userData.find((u: any) => u.id === values.userId) as any)
            ?.name || "";
          dispatch(
            props?.category == Category.CGYW ? getBuildOtherRecipeAsync({
              inventoryReceiptsId: props.data?.id,
              supplierId: props.data?.supplierId,
              supplierName: props.data?.supplierName,
              type: 1,
              upaccountFlag: type == 1 ? false : true,
              approvedFlag: false,
              storehouseName,
              departmentName,
              userName,
              ...values,
              recepitsDate: values?.recepitsDate
                ? moment(values?.recepitsDate).format(DateTimeFormat)
                : "",
              inventoryReceiptsItemSubmitDTOList: page.items?.map((t: any) => {
                return { ...t, productInfo: t.productInfo?.replace(/[<>]/g, '')}
              }),
            }) : getBuildOtherRecipeAsync({
              inventoryReceiptsId: page.items?.[0]?.tenantInventoryReceiptsId,
              supplierId: props.data?.supplierId,
              supplierName: props.data?.supplierName,
              type: 3, 
              upaccountFlag: type == 1 ? false : true,
              approvedFlag: false,
              storehouseName,
              departmentName,
              userName,
              ...values,
              recepitsDate: values?.recepitsDate
                ? moment(values?.recepitsDate).format(DateTimeFormat)
                : "",
              inventoryReceiptsItemSubmitDTOList: page.items?.map((t: any) => {
                return { ...t, productInfo: t.productInfo?.replace(/[<>]/g, '')}
              }),
              inventoryPurchaseAcceptanceMainId: props.data?.id,
            })
          )
            .then(unwrapResult)
            .then(() => {
              type == 1 ? setLoading(false) : setSureLoading(false)
              props.onOk()
              notification.success({
                message: "操作成功",
              })
            })
            .catch(()=>{
              type == 1 ? setLoading(false) : setSureLoading(false)
            })
        }
      }
    })
  }

  useEffect(() => {
    form.setFieldsValue({
      storehouseId: durgsystemData?.[0]?.storehouseId
    })
  }, [durgsystemData])

  useEffect(() => {
    if (props?.visible) {
      setPageLoading(true)
      dispatch(getStorage({ current: 1, flag: 2 }))
      dispatch(DepartmentDate({ current: 1, size: 1000 }))
      if (userId || departmentId) {
        dispatch(getUserName(departmentId))
        form.setFieldsValue({
          departmentId: Number(departmentId),
          userId,
        })
      }
      dispatch(props?.category == Category.CGYW
        ? getInventoryPurchAseacceptanceListAsync(props.data?.id) 
        : getAcceptanceDetailListAsync({id: props.data?.id}))
        .then(unwrapResult)
        .then((res: any) => {
          const data = {
            total: res?.length,
            items: res?.map((v: any) => {
              return {
                ...v,
                arrivalUnitPrice:
                  v.arrivalUnitPrice == -1 ? "" : v.arrivalUnitPrice,
                realCount: v.realCount > 0 ? v.realCount : v.totalQuantity > 0 ? v.totalQuantity : v.count ,
                unitPrice:
                  v.unitPrice >= 0 ? v.unitPrice : v.arrivalUnitPrice,
                totalQuantity: v.totalQuantity >= 0 ? v.totalQuantity : v.count,
                qualifiedQuantity:
                  v.qualifiedQuantity >= 0 ? v.qualifiedQuantity : v.count,
                defectiveQuantity:
                  v.defectiveQuantity >= 0 ? v.defectiveQuantity : 0,
                qualityStatus: v.qualityStatus ? v.qualityStatus : "产品完好无损",
                acceptanceConclusion: v.acceptanceConclusion ? v.acceptanceConclusion : "验收合格",
              }
            }),
          }
          setPage(data)
          setPageLoading(false)
        })
    } else {
      setPage([])
      form.resetFields()
    }
  }, [props?.visible])

  return (
    <>
      {contextHolder}
      <Modal
        title="生成入库单"
        width={1400}
        visible={props?.visible}
        className={styles.copyTBDModal}
        destroyOnClose
        maskClosable={false}
        onCancel={() => {
          props?.onCancel()
        }}
        footer={null}
        centered
      >
        <div>
          <Form
            form={form}
            name="control-hooks"
            autoComplete="off"
            colon={false}
            labelCol={{ span: 7 }}
            initialValues={{
              recepitsDate: moment(),
            }}
            //   onFinish={(fs) => {

            //   }}
          >
            <Row gutter={20}>
              <Col span={6}>
                <Form.Item
                  name="storehouseId"
                  label="库房名称"
                  rules={[
                    {
                      required: true,
                      message: "库房名称不能为空",
                    },
                  ]}
                >
                  <Select placeholder="" allowClear>
                    {durgsystemData.map((v: any, i: number) => {
                      return (
                        <Option value={v.storehouseId} key={i}>
                          {v.storehouseName}
                        </Option>
                      )
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="departmentId"
                  label="业务部门"
                  rules={[
                    {
                      required: true,
                      message: "申请部门不能为空",
                    },
                  ]}
                >
                  <Select
                    placeholder=""
                    allowClear
                    showSearch
                    onSelect={(key: any) => {
                      form.setFieldsValue({
                        userId: undefined,
                      })
                      dispatch(getUserName(key))
                    }}
                  >
                    {departmentData.map((v: Department) => {
                      return (
                        <Option value={v.id} key={v.id}>
                          {v.name}
                        </Option>
                      )
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="userId"
                  label="业务人员"
                  rules={[
                    {
                      required: true,
                      message: "申请人不能为空",
                    },
                  ]}
                >
                  <Select showSearch placeholder="" allowClear>
                    {userData.map((v: User) => {
                      return (
                        <Option value={v.id} key={v.id}>
                          {v.name}
                        </Option>
                      )
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="recepitsDate"
                  label="业务日期"
                  rules={[
                    {
                      required: true,
                      message: "申请日期不能为空",
                    },
                  ]}
                >
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="invoiceNb"
                  label="发票号"
                  getValueFromEvent={stringTrim}
                  rules={[
                    {
                      required: true,
                      message: "发票号不能为空",
                    },
                  ]}
                >
                  <Input placeholder="" allowClear />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="remark"
                  label="备注"
                  getValueFromEvent={stringTrim}
                >
                  <Input placeholder="" allowClear />
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <EditableList
            style={{ maxHeight: "450px", overflow: "auto", marginTop: "15px" }}
            scroll={{ x: "30rem", y: "40rem" }}
            page={{
              items: page.items,
              current: params.current,
              size: params.size,
              total: page.total,
            }}
            loading={pageLoading}
            pagination={false}
            rowKey={(m: any) => m.id}
            columns={StorageColumns(
              params.size * (params.current - 1),
              (text, t) => {
                if (text == "edit") {
                  setPage({
                    ...page,
                    items: page.items?.map((item: any) => {
                      if (item.id == t.id) {
                        return t
                      } else {
                        return item
                      }
                    }),
                  })
                }
              }
            )}
            sticky
          />
          <Row justify="end" style={{ marginTop: "20px" }}>
            <Space>
              <Button onClick={props.onCancel}>取消</Button>
              <Button type="primary" onClick={() => submit(1)} loading={loading}>
                确认
              </Button>
              <Tooltip title="登账后单据生效">
                <Button
                  loading={sureLoading}
                  onClick={() => submit(2)}
                  style={{ backgroundColor: "#FFA037", color: "#fff", border: 'none' }}
                >
                  确认并完成登账
                </Button>
              </Tooltip>
            </Space>
          </Row>
        </div>
      </Modal>
    </>
  )
}
